import React, { useEffect } from "react";
import NumPad from "react-numpad";
import { Box, TextField, Typography } from "@mui/material";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Modal from "@mui/material/Modal";
import DOMPurify from "dompurify";
import "../../pages/admin/StudySetup/Questionnaire/FormBuilder/QuestionnaireCss.css";
import { useAlignment } from "../../context/alignmentFormbuilder/AlignmentContext";
import { checkRuleValue } from "../helpers/helper";
import { useGetRule } from "../../hooks/useRules";

const NumericPad = React.forwardRef((props, ref) => {
  const [openModal, setOpenModal] = React.useState(false);
  const [titleName, setTitleName] = React.useState("");
  const [showTitle, setShowTitle] = React.useState(false);
  const [isDisabled, setDisabled] = React.useState(false);
  const [isVisible, setVisible] = React.useState(true);
  const [value, setValue] = React.useState("");
  const { alignment } = useAlignment();
  const { Rules, triggerUpdate } = useGetRule();

  const {
    textSize,
    width: customWidth,
    MaxValue,
    MinValue,
    subLabel,
  } = props.data;

  useEffect(() => {
    const { form, formResponse } = Rules;
    if (formResponse) {
      const myId = props?.data.id;
      const formItem = form[myId];
      if (
        (formItem && formItem["dependsOn"]) ||
        (formItem && formItem["useCalculation"])
      ) {
        const ruleData = checkRuleValue(formItem, formResponse);
        const { isVisible, isDisable } = ruleData;
        setVisible(isVisible);
        setDisabled(isDisable);
      }
    }
  }, [Rules]);

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleShowTitle = () => {
    if (titleName === "") {
      setShowTitle(false);
    } else {
      setShowTitle(true);
    }
  };

  const handleTitleName = (event) => {
    event.preventDefault();
    setTitleName(event.target.value);
  };

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "none !important",
    boxShadow: 24,
    borderRadius: "3px",
    p: 3,
  };

  const {
    name,
    defaultValue,
    disabled,
    borderTop,
    labelAlignment,
    hide,
    label,
    borderBottom,
    borderSides,
    currentPage,
  } = props;

  const handleChange = (event) => {
    const inputValue = parseInt(event, 10);
  
    // If MinValue and MaxValue are provided, check the range
    if (MinValue && MaxValue) {
      if (inputValue >= MinValue && inputValue <= MaxValue) {
        setValue(inputValue);
        if (props?.set) {
          props?.set({ key: props.data.id, value: inputValue });
        }
      } else {
        setValue("");
        if (props?.set) {
          props?.set({ key: props.data.id, value: "" });
        }
        console.warn(`Value must be between ${MinValue} and ${MaxValue}`);
      }
    } else {
      // If MinValue and MaxValue are not provided, accept any value
      setValue(inputValue);
      if (props?.set) {
        props?.set({ key: props.data.id, value: inputValue });
      }
    }
  
    triggerUpdate(true);
  };
  const sanitizedLabel = DOMPurify.sanitize(label || "");

  return (
    <>
      {isVisible && (
        <div
          className={`${borderTop ? "borderTop " : ""} ${
            borderSides ? "borderSides " : ""
          } ${borderBottom ? "borderBottom " : ""} flexCenter`}
        >
          {currentPage && (
            <div className="currentPage">
              {/* Page <p>{currentPage}</p> */}
              {!showTitle ? (
                <>
                  <Modal
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <Box sx={modalStyle}>
                      <Row>
                        <Col md={12}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              marginBottom: "2%",
                            }}
                          >
                            <h4>Enter Page Title</h4>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={12}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <TextField
                              className="muiTextInput"
                              id="outlined-basic"
                              onChange={handleTitleName}
                              placeholder="Page Title"
                              variant="outlined"
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={12}>
                          <div
                            style={{
                              marginTop: "4%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <button
                              onClick={handleShowTitle}
                              className="saveTitleBtn"
                            >
                              Save
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </Box>
                  </Modal>
                  {/* <button onClick={handleOpenModal} className="addTitleBtn">
                  Add Title
                </button> */}
                  {/* <div className="addTitleBtn">
                  Container Title
                </div> */}
                </>
              ) : (
                <p>{titleName}</p>
              )}
            </div>
          )}
          <div
            className={`removeMargin flex ${
              hide
                ? "hideComponent"
                : alignment === "top"
                ? "flex-col "
                : alignment === "left"
                ? "justify-between items-center gap-20"
                : "justify-end items-center prevSpace gap-5"
            }`}
          >
            <Typography
              className={`custom-typography-class ${disabled ? "labelDisabled" : "labelContainer"}`}
              sx={{ mt: 4, mb: 2 }}
              
              variant="h6"
              component="div"
            >
              <p dangerouslySetInnerHTML={{ __html: sanitizedLabel }} />
            </Typography>
            <div
              className={`ageRangeInputBody flex gap-2 ${
                alignment === "top"
                  ? ""
                  : alignment === "left"
                  ? "order-last"
                  : ""
              }`}
            >
              <div>
                <div className="w-[462px]">
                  <NumPad.Number
                    onChange={(value) => {
                      handleChange(value)
                    }}
                  >
                    <TextField
                      className="muiTextInput max-w-xl"
                      style={{
                        width: customWidth ? `${customWidth}px` : "230px",
                      }}
                      id="outlined-basic"
                      type="number"
                      ref={ref}
                      name={name}
                      value={value}
                      placeholder="Numpad"
                      variant="outlined"
                      defaultValue={defaultValue}
                      disabled={disabled || isDisabled}
                      inputProps={{
                        "aria-label": "Without label",
                        className: "custom-text-class",
                      }}
                      InputProps={{
                        style: {
                          fontSize: textSize ? `${textSize}px` : "12px",
                        },
                      }}
                    />
                  </NumPad.Number>
                </div>
                {subLabel ? (
                  <span className="text-[10px] ml-1">{subLabel}</span>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
});

export default NumericPad;
